import React, {createRef, useEffect} from 'react';
import { withStyles } from "@material-ui/core/styles";
import __ from "lodash";
import PropTypes from 'prop-types';
import { FixedSizeList } from 'react-window';
import { useQueryClient } from 'react-query';
import {Checkbox, ListItem, ListItemText} from "@material-ui/core";

import {useCompanyContacts} from "../../../services/companies";

/* eslint-disable no-use-before-define */
const styles = (theme) => ({
  root: {
    width: '50%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

const checkContact = (list, filteredList, process) => {
  list.forEach(record => {
    const contactMethods = record.contactMethods;
    if (contactMethods && Array.isArray(contactMethods)) {
      contactMethods.forEach(contact => {
        if (__.has(contact, "email")) {
          filteredList.push({contactMethod: contact.email, primary: (process === 'EMAIL')});
        }
        if (__.has(contact, "web")) {
          filteredList.push({contactMethod: contact.web, primary: (process === 'WEB')});
        }
        if (__.has(contact, "phone")) {
          filteredList.push({contactMethod: contact.phone, primary: (process === 'PHONE')});
        }
      })
    }
  })
}

const ContactListLookup = props => {
  const width = props.width || 200;
  const companyUuid = props.companyUuid;
  const airportCode = props.airportCode;
  const process = props.process;
  const canEdit = props.canEdit;

  const tableRef = createRef({state: {lastEditingRow: false}});
  const queryClient = useQueryClient();
  const extraKeys = [props.companyUuid];
  const records = useCompanyContacts({tableRef, queryClient, extraKeys});

  const contacts = [];
  if (records && records.data) {
    const airportContacts = __.filter(records.data, {airportCode: airportCode, role: "FUEL ORDER"});
    checkContact(airportContacts, contacts, process);
    if (contacts.length === 0) {
      const contactList = __.filter(records.data, {airportCode: null, role: "FUEL ORDER"});
      checkContact(contactList, contacts, process);
    }
  }

  const initializeChecked = () => {
    const allChecked = [];
    contacts.forEach(contact => {
      if (contact.primary)
        allChecked.push(contact);
    })

    return allChecked;
  }

  const [checked, setChecked] = React.useState(null);

  if (records.data && checked === null) {
    const initialChecked = initializeChecked();
    setChecked(initialChecked);

    if (props.onChange) {
      let newContactList = "";
      initialChecked.forEach((item, i) => {
        newContactList = newContactList + (i > 0 ? "," : "") + item.contactMethod;
      })
      props.onChange(newContactList);
    }
  }  

  const handleToggle = (value) => () => {
    if (!value.primary)
      return;

    const currentIndex = __.findIndex(checked, value ); //checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    let newContactList = "";
    newChecked.forEach((item, i) => {
      newContactList = newContactList + (i > 0 ? "," : "") + item.contactMethod;
    })

    if (props.onChange)
      props.onChange(newContactList);

    setChecked(newChecked);
  };

  const renderRow = (props) => {
    const {index, style, isScrolling} = props;

    // if (isScrolling)
    //   return (<div style={{minHeight:50}}>&nbsp;</div>);

    const record = contacts[index];
    const labelId = `checkbox-list-label-${record.contactMethod}`;

    return (
      <ListItem key={record.contactMethod} style={style} dense disablePadding button disabled={!canEdit} onClick={handleToggle(record)}>
        {/* <ListItemIcon> */}
          <Checkbox
            style={{padding:3}}
            edge="start"
            checked={checked && __.findIndex(checked, record ) !== -1}
            tabIndex={-1}
            disableRipple
            inputProps={{ 'aria-labelledby': labelId }}
            color='primary'
            disabled={!record.primary}
          />
        {/* </ListItemIcon> */}
        <ListItemText id={labelId} primary={record.contactMethod} />
      </ListItem>
    );
  }

  renderRow.propTypes = {
    index: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
  };

  return (
    records.data
      ?
        <FixedSizeList height={300} width={width} itemSize={38} itemCount={contacts.length} useIsScrolling>
          {renderRow}
        </FixedSizeList>
      :
        <></>
  );

}

export default withStyles(styles) (ContactListLookup);
